export default __webpack_public_path__ + "static/media/reports-on.54d1190d.svg";